/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'
//import {useIntl} from 'react-intl'
import { useParams } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { PageLink, PageTitle } from '../../../../_metronic/layout/core';
import { useAuth } from '../../../modules/auth';
import { getCredentialOne, startSyncPlants } from '../../../services/credentialService';
import { getProcessAtual } from '../../../services/processService';
import { formatDateTimeBarra } from '../../../utils/date';
import { getPlanUsage, getPlantsAllSimple, getPlantsImported, getplantsAll, importedPlants, importedPlantsRabbitMq, postLogin } from '../../../services/plantsService';
import { getUnitBranchAllSimple } from '../../../services/unitBranchService';
import { Loading } from '../../components/Loadings/loading';
import { LoadingSpan } from '../../components/Loadings/loadingSpan';
import { useToast } from '../../components/Toats';
import { TablePlantImported } from './components/tablePlantsImported';
import { TablePlantNotImported } from './components/tablePlantsNotImported';
import { PlanUsage, PlanUsageCards, isPlanExceeded } from './components/tablePlantsNotImported/planUsageImported';
import { addLoadingCredential, removeLoadingCredential } from '../../../utils/LoadingCredentials';
import { useQuery } from 'react-query';
import useSize from '../../../hooks/useSize';

const COD_REF_IMPORTACAO_USINAS = 4;

const usersBreadcrumbs: Array<PageLink> = [
    {
      title: 'Portais',
      path: '/portals',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
]

const PagePlantsImported: FC = () => {
    const user = useAuth()
    const { toggleToast } = useToast();
    const { id } = useParams();
    const {width: largura} = useSize();

    const [credential, setCredential] = useState<any>();
    const [unitBranch, setUnitBranch] = useState<any[]>([]);
    const [plantsNotImported, setPlantsNotImported] = useState<any>([]);
    const [plantsImported, setPlantsImported] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
    const [bloqueadQtdComposite, setBloqueadQtdComposite] = useState<boolean>(false);
    const [loadingSync, setLoadingSync] = useState<boolean>(false);

    const [dataGlobal, setDataGlobal] = useState<any>({
      idCredential: id ? id : null,
      idUnitBranch: null,
      type_plano: "BASICA",
      type_importation: "SIMPLES",
      idParentPlant: null,
      plants_list: []
    });

    const { data: plantsComposite = [], isLoading: loadingPlants, refetch: refreshPlants } = useQuery<any[]>(
      "getPlantsComposites",
      async () => {
        const myPlants = await getPlantsAllSimple("?type_plant=COMPOSTA&activeMarkChildPlants=true");
        return myPlants;
      },
      {
        onError: (error) => {
          toggleToast("Erro ao buscar a lista de usinas compostas. ", "error")
        },
      }
    )

    useQuery<any>(
      ["getProcessSyncPlants", id],
      async () => {
        const status_list = ["PENDENTE", "PROCESSANDO", "CONCLUIDO", "FALHOU"];
        let process: any = null;

        for (const status of status_list) {
          if(!process){
            process = await getProcessAtual({ idCredential: id, status: status, cod_ref: 3 });
          }
        }

        const em_andamento = !!process && (process.status === "PENDENTE" || process.status === "PROCESSANDO");

        setLoadingSync((prevLoadingSync: boolean) => {
          if(prevLoadingSync && !em_andamento){
            if(process && process.status === "CONCLUIDO"){
              toggleToast("Sincronização das usinas concluída!", "success");
            }
            if(process && process.status === "FALHOU"){
              toggleToast(process.description ? process.description : "Erro ao sincronizar as usinas do portal!", "error");
            }
            getCredential();
            getMyPlantsImported();
          }
          return em_andamento;
        });

        return process;
      },
      {
        enabled: !!id,
        refetchInterval: id ? 5000 : false,
        onError: (error) => {
          console.log(error);
        },
      }
    )

    // plantsImported.length na chave: após uma importação o uso dos planos é buscado de novo
    const { data: planUsage = [], isLoading: loadingPlanUsage } = useQuery<PlanUsage[]>(
      ["getPlanUsage", dataGlobal.idUnitBranch, plantsImported.length],
      () => getPlanUsage(dataGlobal.idUnitBranch),
      {
        enabled: !!dataGlobal.idUnitBranch,
        onError: (error) => {
          console.log(error)
        },
      }
    )

    // mesma regra do backend: só as usinas ainda não importadas contam no plano
    const newSelected = dataGlobal.plants_list.filter(
      (plantId: any) => !plantsImported.some((plant: any) => String(plant.plantId) === String(plantId))
    ).length

    const selectedPlanUsage = planUsage.find((plan) => plan.plano === dataGlobal.type_plano)

    // enquanto o POST de importação não responde, o processo ainda pode não existir
    const submittingImport = useRef<boolean>(false);

    const { refetch: refetchProcessImported } = useQuery<any>(
      ["getProcessImportedPlants", id],
      async () => {
        if(submittingImport.current){
          return null;
        }

        const status_list = ["PENDENTE", "PROCESSANDO", "CONCLUIDO", "FALHOU"];
        let process: any = null;

        for (const status of status_list) {
          if(!process){
            process = await getProcessAtual({ idCredential: id, status: status, cod_ref: COD_REF_IMPORTACAO_USINAS });
          }
        }

        const em_andamento = !!process && (process.status === "PENDENTE" || process.status === "PROCESSANDO");

        setLoadingSubmit((prevLoadingSubmit: boolean) => {
          if(prevLoadingSubmit && !em_andamento){
            if(process && process.status === "CONCLUIDO"){
              toggleToast(process.description ? process.description : "Sucesso ao importar suas usinas!", "success");
            }
            if(process && process.status === "FALHOU"){
              toggleToast(process.description ? process.description : "Erro ao importar as usinas!", "error");
            }
            removeLoadingCredential(id ? id : "");
            refresh();
          }
          return em_andamento;
        });

        return process;
      },
      {
        enabled: !!id,
        refetchInterval: id ? 5000 : false,
        onError: (error) => {
          console.log(error);
        },
      }
    )

    const submitSync = async () => {
      try {
        setLoadingSync(true);
        const result = await startSyncPlants(id ? id : "");
        toggleToast(
          result && result.message
          ? result.message
          : "Sincronização das usinas adicionada à fila. Aguarde!", "alert"
        );

      } catch (error: any) {
        setLoadingSync(false);
        toggleToast(
          error && error.response
          && error.response.data
          && error.response.data.message
          ? error.response.data.message
          : "Erro ao solicitar a sincronização das usinas!", "error"
        );
      }
    }

    const addValuesData = (value: any, check: boolean) => {
      if(typeof value === 'string'){
        setDataGlobal((prevDataGlobal) => {
          const newPlantsList = [...prevDataGlobal.plants_list];

          if (check) {
            if (!newPlantsList.includes(value)) {
              newPlantsList.push(value);
            }
  
          } else {
            const index = newPlantsList.indexOf(value);
            if (index !== -1) {
              newPlantsList.splice(index, 1);
            }
          }
          return {
            ...prevDataGlobal,
            plants_list: newPlantsList,
          };
        });
      }else{
        setDataGlobal((prevDataGlobal) => {
          const newPlantsList = [...prevDataGlobal.plants_list];
      
          if (check) {
            if (!newPlantsList.includes(Number(value))) {
              newPlantsList.push(Number(value));
            }
  
          } else {
            const index = newPlantsList.indexOf(Number(value));
            if (index !== -1) {
              newPlantsList.splice(index, 1);
            }
          }
          return {
            ...prevDataGlobal,
            plants_list: newPlantsList,
          };
        });
      }

    }

    const addValuesDataAll = (idUnitBranch: string) => {
      setDataGlobal((prevDataGlobal: any) => ({
        ...prevDataGlobal,
        idUnitBranch: idUnitBranch
      }));
    }

    const addValuesDataAllTypeImportation = (type_importation: string) => {
      setDataGlobal((prevDataGlobal: any) => ({
        ...prevDataGlobal,
        type_importation: type_importation
      }));
    }

    const addValuesDataAllPlantComposite = (idParentPlant: string | null) => {
      setDataGlobal((prevDataGlobal: any) => ({
        ...prevDataGlobal,
        idParentPlant: idParentPlant
      }));
    }

    const addValuesDataAllTypePlano = (type_plano: string) => {
      setDataGlobal((prevDataGlobal: any) => ({
        ...prevDataGlobal,
        type_plano: type_plano
      }));
    }

    // const verificadQtdPlantComposite = () => {
    //   setBloqueadQtdComposite(false);
      
    //   if(dataGlobal.type_importation === "COMPOSTA"){
    //     if(dataGlobal.idParentPlant 
    //       && plantsComposite 
    //       && plantsComposite.length > 0
    //       && credential && credential.mark
    //     ){

    //       const myPlantComposite = plantsComposite.find((plant: any) => plant.id === dataGlobal.idParentPlant);
    //       if(myPlantComposite && myPlantComposite.marks && myPlantComposite.marks.length > 0){

    //         myPlantComposite.marks.map((mark: any) => {
    //           if(mark.id === credential.mark.id){
    //             setBloqueadQtdComposite(true);
    //           }
    //         })
    //       }else{
    //         setBloqueadQtdComposite(false);
    //       }

    //       if(dataGlobal.plants_list.length > (plantsImported.length + 1)){
    //         setBloqueadQtdComposite(true);
    //       }
    //     }else{
    //       setBloqueadQtdComposite(false);
    //     }
    //   }else{
    //     setBloqueadQtdComposite(false);
    //   }

    // }

    const verificadQtdPlantComposite = () => {
      setBloqueadQtdComposite(false);
    }

    const getCredential = async () => {
      try {
        const myCredential = await getCredentialOne(id ? id : "")
        setCredential(myCredential)

        if(myCredential){
          var list_imports = sessionStorage.getItem('list_imports');
      
          if(list_imports){
            var my_list_imports_finaly = JSON.parse(list_imports);
            let search_item = my_list_imports_finaly.some((item : any) => item.id == myCredential.id)
            if(search_item){
              setLoadingSubmit(true)
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }

    const getUnitBranch = async () => {
      try {
        const unitBranch = await getUnitBranchAllSimple();
        setUnitBranch(unitBranch);

        if(unitBranch && unitBranch.length > 0){
          const matrizUnit = unitBranch.find(unit => unit.tipo === "MATRIZ");
  
          if (matrizUnit) {
            setDataGlobal(prevState => ({
              ...prevState,
              idUnitBranch: matrizUnit.id
            }));
          }
        }
  
      } catch (error) {
        console.log(error)
        //toggleToast("Erro ao buscar as unidades filiais. ", "error")
      }
    }


    const getMyPlantsImported = async () => {
      try {
        setLoading(true)
        const myPlantsImported = await getPlantsImported(id ? id : "")
        
        const plants_imported = myPlantsImported.filter((plant: any) => plant.imported === true)
        setPlantsImported(plants_imported)
        plants_imported.map((plant: any) => addValuesData(plant.plantId, true))

        setPlantsNotImported(myPlantsImported.filter((plant: any) => plant.imported === false))

        // a consulta da lista de usinas atualiza o synced_at da credencial (header x-last-sync-at)
        await getCredential()

      } catch (error: any) {
        toggleToast(
          error && error.response 
          && error.response.data 
          && error.response.data.message 
          ? error.response.data.message 
          : "Erro ao buscar usinas nesse credencial!", "error"
        )

      }finally{
        setLoading(false)
      }
    }
  
    const refresh = () => {
      getMyPlantsImported()
    }

    // const submit = async () => {
    //   try {
    //     setLoadingSubmit(true)
    //     toggleToast("Processo de importação em andamento. Aguarde! ", "alert")
        
    //     var list_imports = sessionStorage.getItem('list_imports');
        
    //     if(list_imports){
    //       var my_list_imports = JSON.parse(list_imports);
    //       my_list_imports.push({credential: credential.username, status: true})
    //       var arrayString = JSON.stringify(my_list_imports);
    //       sessionStorage.setItem('list_imports', arrayString);
        
    //     }else{
    //       let my_list_import: any[] = [];
    //       my_list_import.push({credential: credential.username, status: true})
    //       var arrayString = JSON.stringify(my_list_import);
    //       sessionStorage.setItem('list_imports', arrayString);
    //     }

    //     await postLogin(dataGlobal)
    //     toggleToast(`Sucesso ao importar suas usinas! credential -  ${credential.username}, portal - ${credential.mark.name}`, "success")

    //     var list_imports_finaly = sessionStorage.getItem('list_imports');

    //     if(list_imports_finaly){
    //       var my_list_imports_finaly = JSON.parse(list_imports_finaly);
    //       const list_filter = my_list_imports_finaly.filter((item: any) => item.credential != credential.username)
    //       var arrayString = JSON.stringify(list_filter);
    //       sessionStorage.setItem('list_imports', arrayString);
    //     }
    //     setLoadingSubmit(false)
    //     refresh()
      
    //   } catch (error: any) {

    //     toggleToast(
    //       error && error.response 
    //       && error.response.data 
    //       && error.response.data.message 
    //       ? error.response.data.message 
    //       : `Erro ao importar as usinas! credencial - ${credential.username}, portal -  ${credential.mark.name}`, "error"
    //     )
        
    //     //toggleToast(`Erro ao importar as usinas! credentail - ${credential.username}, portal -  ${credential.mark.name}`, "error")

    //     var list_imports_finaly = sessionStorage.getItem('list_imports');

    //     if(list_imports_finaly){
    //       var my_list_imports_finaly = JSON.parse(list_imports_finaly);
    //       const list_filter = my_list_imports_finaly.filter((item: any) => item.credential != credential.username)
    //       var arrayString = JSON.stringify(list_filter);
    //       sessionStorage.setItem('list_imports', arrayString);
    //     }
    //     setLoadingSubmit(false)
    //     refresh()

    //   }
    // }

    const submit = async () => {
      try {
        submittingImport.current = true
        setLoadingSubmit(true)
        addLoadingCredential(credential)

        const result = await importedPlants(dataGlobal);

        if(result){
          toggleToast(`${result.message}`, "alert")
        }

        submittingImport.current = false
        refetchProcessImported()

      } catch (error: any) {
        submittingImport.current = false

        toggleToast(
          error && error.response 
          && error.response.data 
          && error.response.data.message 
          ? error.response.data.message 
          : `Erro ao importar as usinas! credencial - ${credential.username}, portal -  ${credential.mark.name}`, "error"
        )

        removeLoadingCredential(credential.id)
        setLoadingSubmit(false)
      }
    }

    useEffect(() => {
      getCredential()
      getMyPlantsImported()
      getUnitBranch()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      if(dataGlobal.type_importation === "COMPOSTA"){
        verificadQtdPlantComposite();
      }else{
        setBloqueadQtdComposite(false)
      }
    }, [dataGlobal]);


    if (!credential) {
      return (
        <div style={{display: 'flex', justifyContent: 'center', height: '30rem', alignItems: 'center'}}>
          <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}}/>
        </div>
        
      )
      //return <h1>Carrengando...</h1>;
    }
  return (
    <div className='row g-5 g-xl-8'>
        <div className='mt-xl-9 mb-xl-0 py-3' style={{display: 'flex',gap: '1rem', alignItems: largura < 1200 ? 'start' : 'center',justifyContent: 'space-between', flexDirection: largura < 1200 ? 'column' : 'row'}}>
            <div className='border-0' style={{display: 'flex', alignItems: 'center'}}>
                <div className='symbol symbol-70px me-5 bg-light'>
                {credential && credential.mark && credential.mark.link_imagem ? 
                  (<img
                      src={toAbsoluteUrl(`${credential.mark.link_imagem}`)}
                      className=''
                      alt=''
                  />) 
                  :
                    <KTSVG path="/media/icons/duotune/coding/cod009.svg" className="svg-icon-muted svg-icon-3hx" />}
                    {/*<img src={toAbsoluteUrl('/media/avatars/300-6.jpg')} className='' alt='' />*/}
                </div>
                <h3 style={{display: "flex", flexDirection: "column"}}>
                    <span className='card-label fw-bold fs-1 mb-1'>{credential.mark.name ? credential.mark.name : "Portal"}</span>
                    <span className='text-muted mt-1 fw-semibold fs-6'>{credential.username ? credential.username : "credencial@credencial"}</span>
                </h3>
            </div>

            {!loadingSubmit && (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: largura < 1200 ? 'start' : 'end', gap: '0.25rem'}}>
              <button
                type='button'
                className='btn btn-sm btn-primary'
                onClick={submitSync}
                disabled={loadingSync}
              >
                {loadingSync ? (
                  <>
                    Sincronizando...
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                  </>
                ) : (
                  <>
                    <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-3 me-1' />
                    Sincronizar
                  </>
                )}
              </button>
              <span className='text-muted fw-semibold fs-7'>
                Última sincronização: {credential.synced_at ? formatDateTimeBarra(credential.synced_at) : "nunca sincronizado"}
              </span>
            </div>
            )}
            {loadingSubmit && (
              <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
                <h3 style={{display: "flex", flexDirection: "column"}}>
                  <span className='text-gray-700 mt-1 fw-semibold fs-6'>
                    Importando usinas, aguarde! {" "}{" "}
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>  
                  </span>
                </h3>
              </div>
            )}
            
            {/* {loadingSubmit && (
              <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
                <h3 style={{display: "flex", flexDirection: "column"}}>
                  <span className='text-gray-700 mt-1 fw-semibold fs-6'>
                    Importando usinas, aguarde! {" "}{" "}
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>  
                  </span>
                </h3>
              </div>
            )} */}

                {bloqueadQtdComposite && (
                    <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed flex-shrink-0 p-6'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen044.svg'
                        className='svg-icon-2tx svg-icon-danger me-4'
                      />
                      <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                        <div className='mb-3 mb-md-0 fw-bold'>
                          <div className='fs-6 text-danger pe-7'>
                            *A usina COMPOSTA ({plantsComposite?.find((plant: any) => plant.id === dataGlobal.idParentPlant)?.plantName ?? ''}) só pode conter 1 usina SIMPLES por marca (portal)
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

        </div>
        
        {user.currentUser?.role.slug !== "CLIENTE" && (
          // marginTop sobrescreve o gutter da row para os cards ficarem mais perto do header
          <div style={{marginTop: '0.5rem'}}>
            <PlanUsageCards
              planUsage={planUsage}
              loading={!!dataGlobal.idUnitBranch && loadingPlanUsage}
              typePlano={dataGlobal.type_plano}
              newSelected={newSelected}
              disabled={loading || loadingSubmit}
              onSelectPlano={addValuesDataAllTypePlano}
            />
          </div>
        )}

        <div className='row g-5 g-xl-3'>
          {
            user.currentUser?.role.slug !== "CLIENTE" &&(
              <div className='col-xl-6'>
                <TablePlantNotImported 
                  className='card-xl-stretch mb-xl-8' 
                  plants={plantsNotImported}
                  plantsImported={plantsImported} 
                  loading={loading}
                  addValuesData={addValuesData}
                  submit={submit}
                  loadingSubmit={loadingSubmit}
                  
                  unit_branchs={unitBranch}
                  plantsComposite={plantsComposite}

                  dataGlobal={dataGlobal}
                  setDataGlobal={setDataGlobal}
                  refreshPlants={refreshPlants}
                  // typeImportation={dataGlobal.type_importation}
                  // plants_list={dataGlobal.plants_list}

                  
                  addValuesDataAll={addValuesDataAll}
                  addValuesDataAllStatus={addValuesDataAllTypePlano}
                  addValuesDataAllTypeImportation={addValuesDataAllTypeImportation}
                  addValuesDataAllPlantComposite={addValuesDataAllPlantComposite}

                  bloqueadQtdComposite={bloqueadQtdComposite}
                  selectedPlanUsage={selectedPlanUsage}
                  newSelected={newSelected}
                  exceededPlan={isPlanExceeded(selectedPlanUsage, newSelected)}

                />
              </div>
            ) 
          }
            <div className={`col-xl-${user.currentUser?.role.slug === "CLIENTE" ? "12" : "6"}`}>
                <TablePlantImported className='card-xl-stretch mb-5 mb-xl-8' plants={plantsImported} loading={loading} refresh={refresh}/>
            </div>
      </div>

        {/*<div className='card mb-5 mb-xl-10'>
            <div className='card-header border-0 pt-5 flex-column'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>Usinas (Importadas)</span>
                    <span className='text-muted mt-1 fw-semibold fs-7'>Total: 5 usinas</span>
                </h3>
            </div>
            
            <div className='card-body py-3'>
                <h1></h1>
            </div>
  </div>*/}
    </div>
    
  )
}

const PagePlantsImportedByCredential: FC = () => {

  return (
    <>
      <PageTitle breadcrumbs={usersBreadcrumbs}>{`Importação de usinas`}</PageTitle>
      <PagePlantsImported />
    </>
  )
}

export {PagePlantsImportedByCredential}
